import { Field, InputType } from 'type-graphql'

@InputType()
export class LogoutArgs {
  @Field(() => String)
  accessToken: string
}
